/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Source_InheritedInputs */



/**
* | output |
* | --- |
* | "Org default shown — team grants or floors are not included; effective access can differ." |
*
* @param {Rights_Source_InheritedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_source_inherited = /** @type {((inputs?: Rights_Source_InheritedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Source_InheritedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Org-Standard angezeigt – Team-Gewährungen oder -Sperren sind nicht berücksichtigt; der effektive Zugriff kann abweichen.")
	return /** @type {LocalizedString} */ ("Org default shown — team grants or floors are not included; effective access can differ.")
});